import React, { useState, useRef } from "react";
import { Modal, ModalBody, ModalHeader, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../Action";
import { bindActionCreators } from "redux";
import "./ProfilePictureModalStyles.css";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { setProfilePicture } from "../../../API/api";
import { toast } from "react-toastify";
import { CURRENT_ROLE } from "../../../API/url";
import VizButton from "../../VizButtons/VizButton";
import { handleError } from "../../../utils";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ModalHeader as ModalHeaderStyles } from "../../../Constants";



const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});



export default function ProfilePictureModal() {
	const modalState = useSelector((state) => state.domain);
	const dispatch = useDispatch();
	const { advanceFilterModalToggle, profilePagePictureData } = bindActionCreators(Actions, dispatch);
	const profilePictureState = useSelector(state => state.profilePage);
	const [srcImg, setSrcImg] = useState(profilePictureState.profilePic);
	const [image, setImage] = useState(null);
	const [crop, setCrop] = useState({
		width: 100,
		height: 100
	});
	const [result, setResult] = useState(null);
	const [disabled, setDisabled] = useState(false);
	const [imageBlob, setImgBlob] = useState(null);
	const handleImage = async (e) => {
		if (e.target.files[0].size > maxFileSize) {
			setDisabled(!disabled);
		}
		else {
			setSrcImg(URL.createObjectURL(e.target.files[0]));
			setDisabled(false);
		}
	};

	const maxFileSize = 2000000;

	const getCroppedImg = async () => {
		const canvas = document.createElement("canvas");
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width;
		canvas.height = crop.height;
		const ctx = canvas.getContext("2d");
		ctx.imageSmoothingQuality = 'high';
		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width,
			crop.height
		);
		const base64Image = canvas.toDataURL("image/jpeg");
		const blobData = canvas;
		setImgBlob(blobData);
		setResult(base64Image);

	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		imageBlob.toBlob((img) => {
			setProfilePicture(img).then((res) => {
				if (res===undefined) return;
				advanceFilterModalToggle({ bool: false, value: "" })
				profilePagePictureData(result);
				toast.success(
					ToggleButtonToast()
				, {
					position: toast.POSITION.TOP_RIGHT,
				});
			}).catch((err) => handleError(err))
		});
	}

	const ToggleButtonToast = () => {
		return (
			<>
				<span style={{ fontSize: "12px" }}>
					Profile Picture has been updated.
				</span>
			</>
		);
	};

	const onButtonClick = () => {
		// inputFile.current.click();
	};


	const inputFile = useRef(null)
	return (
		<>
			<Modal show={modalState.modalState}
				onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
				size={"md"}
				backdrop="static"
				keyboard={false}
				centered={true}
				style={{ marginTop: '38px' }}
			>
				<ModalHeader style={{alignItems:'center',display:'flex'}} closeButton><h6 style={{...ModalHeaderStyles.styles,marginBottom:0}}  >Update Profile Picture</h6></ModalHeader>
				<ModalBody>
					<div className="cropSection">
						<div style={{ height: "inherit", display: "flex", justifyContent: "center" }}>
							{srcImg && (
								<div style={{ marginTop: "auto", marginBottom: "auto" }}>
									<ReactCrop
										src={srcImg || require('../../../Images/cliente.png')}
										crop={crop}
										onImageLoaded={setImage}
										onChange={setCrop}
										keepSelection={true}
										minHeight={75}
										minWidth={75}
										maxHeight={250}
										maxWidth={250}
									>
									</ReactCrop>
								</div>
							)}
						</div>
					</div>
					<div className="text-end" style={{ marginTop: "12px" }}>
						<Form onSubmit={handleSubmit} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline',gap:'5px' }}>
							{CURRENT_ROLE !== 'CM' &&
							<>
							<input type="file" ref={inputFile} id="uploadFile1" style={{ display: 'none' }} accept="image/png, image/jpeg, image/jpg" onChange={(e) => handleImage(e)} />
							<Button2 type="dark" id="uploadFile1" onClickFunc={()=>inputFile.current.click()} children={'Choose Picture'} />
							</>
								}
							{/* {CURRENT_ROLE !== 'CM' && <label className="btn btn-warning" id="btnApply" for="uploadFile1">Choose Picture</label>} */}
							{CURRENT_ROLE === 'CM' &&
								<>
									{/* <label for="uploadFile1" className="btnApply2">Choose Picture</label> */}
								</>
							}
							{/* {CURRENT_ROLE !== 'CM' && <button className="btn btn-warning" id="submitBtn" onClick={getCroppedImg} disabled={disabled ? true : false}>Apply</button>} */}
							{CURRENT_ROLE !== 'CM' && 
							<>
							<input type="file" ref={inputFile} id="uploadFile1" style={{ display: 'none' }} accept="image/png, image/jpeg, image/jpg" onChange={(e) => handleImage(e)} >
									</input> <Button type={'primary'} text="Apply" onClickFunc={()=>getCroppedImg()} disabled={disabled ? true : false} /></>}
							{CURRENT_ROLE === 'CM'
								&&
								<div style={{ margin: "3px" }}>
									{disabled ? <VizButton size={3} type={"Disabled"}>Apply</VizButton>
										:

										<button onClick={getCroppedImg} className="btn btnApply2">Apply</button>
									}
								</div>
							}
						</Form>
					</div>
					<div style={{ marginTop: "7px" }}>
						<span className="modalText">{disabled && <p style={{ color: "red", marginBottom: 0 }}>Image size exceeds maximum limit 2
							MB.</p>}<p style={{ marginBottom: 0 }}>Images are allowed with maximum size of 2 MB.</p></span>
						<span className="modalText">jpg, png, jpeg files are accepted.</span>
					</div>
				</ModalBody>
			</Modal>
		</>
	)
}

